export default "__VITE_ASSET__BO2gKSa0__"